import { SessionService } from 'services';
import { ApiServiceError } from './ApiService';

const { REACT_APP_ONCHAINID_API, REACT_APP_DFNS_APP_ID } = process.env;

const fetchFromOnchainId = async ({ path, method, headers = {}, body = null, queryParams }) => {
  const url = new URL(REACT_APP_ONCHAINID_API + path);
  url.search = new URLSearchParams(queryParams);

  const accessToken = await SessionService.getToken();

  const response = await fetch(url.toString(), {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  try {
    const returnBody = await response.json();
    if (!response.ok) throw new ApiServiceError(returnBody);
    return returnBody;
  } catch (e) {
    if (!response.ok) throw new ApiServiceError(e);
    return;
  }
};

const getWallets = async () => {
  return await fetchFromOnchainId({
    path: '/wallets',
    method: 'GET',
  });
};

const postWallet = async ({ walletAddress, provider, alias, signature, source }) => {
  return await fetchFromOnchainId({
    path: '/wallets',
    method: 'POST',
    body: {
      walletAddress,
      provider,
      alias,
      signature,
      source,
    },
  });
};

const registerInit = async ({ walletAddress }) => {
  return await fetchFromOnchainId({
    path: `/wallets/${walletAddress}/verifying-message`,
    method: 'GET',
    headers: {
      'X-INTEGRATED-APP-ID': REACT_APP_DFNS_APP_ID,
    },
  });
};

const registerComplete = async ({ walletAddress, authToken, challenge }) => {
  return await fetchFromOnchainId({
    path: `/wallets/${walletAddress}/verify`,
    method: 'POST',
    headers: {
      'X-INTEGRATED-APP-ID': REACT_APP_DFNS_APP_ID,
    },
    body: {
      authToken,
      challenge,
    },
  });
};

export default {
  getWallets,
  postWallet,
  registerInit,
  registerComplete,
};
